import { Grid, Paper, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { makeStyles } from "@material-ui/styles";
import ColorButton from "components/common/ColorButton";
import { get } from "lodash";
import React from "react";
import { useSelector } from "react-redux";
import { selectDocumentRequired } from "redux/modules/visaForm";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#f1f3f9",
    color: "#172b4d",
    fontSize: 16,
  },
  body: {
    fontSize: 16,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.background.main,
    },
  },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    padding: "18px 48px",
  },
  title: {
    color: theme.palette.darkIndigo.main,
  },
  subTitle: {
    "& a": {
      color: theme.palette.secondary.main,
    },
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  circle: {
    width: 25,
    height: 25,
    borderRadius: 25,
    backgroundColor: theme.palette.error.main,
  },
  triangle: {
    margint: 0,
    padding: 0,
    fontSize: 30,
    color: theme.palette.success.main,
  },
  table: {
    minWidth: 700,
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
  },
  badge: {
    display: "flex",
    width: 25,
    height: 25,
    borderRadius: 25,
    backgroundColor: "#feb969",
    marginRight: 8,
    textAlign: "center",
    color: "#fff",
    justifyContent: "center",
    alignItems: "center",
  },
  wrapTitleContent: {
    width: 78,
    display: "flex",
    justifyContent: "center",
  },
  tableTitle: {
    color: "#172b4d",
    marginLeft: 18,
  },
}));

const DocumentStatus = ({ status }) => {
  const classes = useStyles();

  if (status === "mandatory") {
    return (
      <div className={classes.flexRow}>
        <div className={classes.circle}></div>
      </div>
    );
  } else if (status === "applicable") {
    return <span className={classes.triangle}>▲</span>;
  }

  return null;
};

export default function RequestTalentInfo({
  onCancel = () => { },
  onSubmit = () => { },
}) {
  const classes = useStyles();
  const { data: documentRequired } = useSelector(selectDocumentRequired);

  const smartserviceName = get(documentRequired, "0.smartserviceName", "");
  const description = get(documentRequired, "0.description", "");
  const ducumentTitle = `${smartserviceName} ${description}`;

  const getTopicStatus = (status) => {
    if (status === null) return "";
    return status ? "mandatory" : "applicable";
  };

  const bySeqDoc = (a, b) => parseInt(a.seqDoc) - parseInt(b.seqDoc);
  const bySeqTypeDoc = (a, b) =>
    parseInt(a.seqTypedoc) - parseInt(b.seqTypedoc);
  const flatterTopic = (p, c) => [...p, ...c.topic];

  const documents = documentRequired
    .reduce((prev, cur) => {
      const matchByseqTypedoc = (v) => v.seqTypedoc === cur.seqTypedoc;
      const notMatchByseqTypedoc = (v) => v.seqTypedoc !== cur.seqTypedoc;

      if (prev.some(matchByseqTypedoc)) {
        const listByseqTypedoc = prev
          .filter(matchByseqTypedoc)
          .reduce(flatterTopic, []);

        const otherList = prev.filter(notMatchByseqTypedoc);

        return [
          ...otherList,
          {
            seqTypedoc: cur.seqTypedoc,
            title: cur.typeDocumentName,
            topic: [
              ...listByseqTypedoc,
              {
                title: cur.documentName,
                seqDoc: cur.seqDoc,
                blank: getTopicStatus(cur.blank),
              },
            ].sort(bySeqDoc),
          },
        ];
      }

      return [
        ...prev,
        {
          seqTypedoc: cur.seqTypedoc,
          title: cur.typeDocumentName,
          topic: [
            {
              title: cur.documentName,
              seqDoc: cur.seqDoc,
              blank: getTopicStatus(cur.blank),
            },
          ],
        },
      ];
    }, [])
    .sort(bySeqTypeDoc);

  const countPrevTopic = (docIndex) =>
    documents.reduce((p, c, i) => {
      if (i === docIndex || i > docIndex) return p;
      return p + c.topic.length;
    }, 0);

  return (
    <div className={classes.root}>
      <Typography variant="h6" className={classes.title}>
        Required Documents for Qualification Endorsement for {ducumentTitle}
      </Typography>
      <Typography variant="h4" color="secondary">
        Documents Required for {ducumentTitle}
      </Typography>

      <Grid
        container
        style={{ marginTop: 30, display: "flex", alignItems: "center" }}
      >
        <Grid item xs={12} md={9}>
          <Typography className={classes.subTitle}>
            Further guidance on the required documents is available on
            <a
              target="_blank"
              href="http://smart-visa.boi.go.th"
              rel="noreferrer"
            >
              {" "}
              http://smart-visa.boi.go.th
            </a>
          </Typography>
        </Grid>
        <Grid item className={classes.flexRow}>
          <div className={classes.circle}></div>
          <Typography style={{ marginLeft: 10, marginRight: 10 }}>
            Mandatory
          </Typography>
        </Grid>
        <Grid item className={classes.flexRow}>
          <span className={classes.triangle}>▲</span>
          <Typography style={{ marginLeft: 10 }}>If applicable</Typography>
        </Grid>
      </Grid>

      <TableContainer
        style={{ marginTop: 12, borderRadius: 4 }}
        component={Paper}
      >
        {documents.map((doc, docIndex) => (
          <Table className={classes.table} key={doc.seqTypedoc}>
            <TableHead>
              <TableRow>
                <StyledTableCell>
                  <Typography variant="h6" className={classes.tableTitle}>
                    {doc.title}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell align="center" width={250}>
                  {docIndex === 0 && "Blank"}
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {doc.topic.map((row, index) => (
                <StyledTableRow key={row.seqDoc}>
                  <StyledTableCell component="th" scope="row">
                    <div style={{ display: "flex" }}>
                      <div className={classes.wrapTitleContent}>
                        <div className={classes.badge}>
                          {countPrevTopic(docIndex) + index + 1}
                        </div>
                      </div>
                      <div style={{ display: "flex", flex: 1 }}>
                        <Typography>{row.title}</Typography>
                      </div>
                    </div>
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {docIndex !== documents.length - 1 && (
                      <DocumentStatus status={row.blank} />
                    )}
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        ))}
      </TableContainer>
      <br />
      <br />
      <div className={classes.flexRow}>
        <ColorButton
          variant="outlined"
          color="secondary"
          style={{ width: 120 }}
          onClick={onCancel}
        >
          BACK
        </ColorButton>
        <ColorButton
          variant="contained"
          color="primary"
          style={{ width: 120, marginLeft: 20 }}
          onClick={onSubmit}
        >
          SUBMIT
        </ColorButton>
      </div>
      <br />
      <br />
    </div>
  );
}
